/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationUtilizationMetric {
    getFixupPrototypeFunction() { return ScheduleRecommendationUtilizationMetric.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationUtilizationMetric>): ScheduleRecommendationUtilizationMetric {
        let obj = Object.assign(new ScheduleRecommendationUtilizationMetric(), model);
        ScheduleRecommendationUtilizationMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationUtilizationMetric>): ScheduleRecommendationUtilizationMetric {
        if (!model) return null;
        return ScheduleRecommendationUtilizationMetric.newInstance(<ScheduleRecommendationUtilizationMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationUtilizationMetric) {
        if (!obj) return;

        models.ScheduleRecommendationUtilizationMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationUtilizationMetric): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationUtilizationMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.utilization === undefined) {
            this.utilization = 0;
        }
        if (typeof this.time === "string") {
            this.time = new Date(<string><any>this.time);
        }
    }

    /**
     * StartTime of Utilization
     */
    time: Date;

    day: models.DayOfWeek;

    /**
     * Utilization Value
     */
    utilization: number;

}
